export default __webpack_public_path__ + "static/media/wwr-img.b95c8404.webp";